
import { DialogSaurus } from '../dialog-saurus/dialog-saurus';
import { useStyles } from './dialog-suporte-styles';
import { useThemeQueries } from 'views';
import { QRCodeSVG } from 'qrcode.react';
import React, { useCallback } from 'react';
import { WhatsappIcon } from 'views/components/icons/whatsapp-icon';
import { VoltarIcon } from 'views/components/icons';
import { useCadastros, useSessaoAtual } from 'services/app';
import { Box, Button, Grid, Typography } from '@material-ui/core';

interface DialogSuporteProps {
  openned: boolean;
}

export const DialogSuporte = ({
  openned,
}: DialogSuporteProps) => {

  //AUX
  const classes = useStyles();
  const { theme } = useThemeQueries();
  const { usuario } = useSessaoAtual();
  const { fecharSuporteWhatsapp } = useCadastros();

  const message = `Olá estou precisando de uma ajuda aqui, pode me ajudar? Nome Comercial: ${usuario?.NomeComercial}`.replace(/ /g, '%20')

  const urlWhatsapp = `https://api.whatsapp.com/send?phone=5511988953751&text=${message}`;

  const abrirWhatsapp = useCallback(() => {
    window.open(`${urlWhatsapp}`, '_blank');
  }, [urlWhatsapp])

  return (
    <DialogSaurus
      icone={
        <WhatsappIcon tipo="BUTTON" fill={`${theme.palette.primary.main}`} />
      }
      colorTitulo={`${theme.palette.primary.main}`}
      centralizarTitulo={true}
      aberto={openned || false}
      titulo="Precisa de Ajuda?"
      tamanho="xs"
      bottomArea={
        <div className={classes.buttomBottom}>
          <Button
            variant="outlined"
            fullWidth
            color="primary"
            onClick={() => {
              fecharSuporteWhatsapp();
            }}
          >
            <VoltarIcon tipo='BUTTON' />
            Voltar
          </Button>
        </div>
      }
    >
      <Box className={classes.cardContainer}>
        <Box className={classes.cardContent}>
          <Box style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Box style={{ flex: 1, justifyContent: 'center' }}>
              <Typography className={classes.label}>
                Nosso suporte está sempre pronto para te ajudar!
              </Typography>
              <Typography className={classes.label}>
                Para realizar o suporte, você precisa ler este qrCode em seu
                celular para iniciar um atendimento via Whatsapp. É mais prático
                e rápido!
              </Typography>
              <div className={classes.qrcode}>
                <QRCodeSVG value={`${urlWhatsapp}`} size={180} />
                <Typography variant="caption" className={classes.qrText}>
                  Leia o QRCode para iniciar <br /> um atendimento.
                </Typography>
              </div>
            </Box>
            <Grid
              container
              spacing={2}
              style={{ marginTop: 16, marginBottom: 8 }}
            >
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={abrirWhatsapp}
                >
                  <WhatsappIcon tipo='BUTTON_PRIMARY' fill={theme.palette.background.default} />
                  Abrir WhatsApp
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </DialogSaurus>
  );
};